<div class="" fxLayout="column" fxLayoutAlign="start center">
    <ng-container *ngIf="data.tipo == 'recordatorios'">
        <ng-container *ngIf="data.fechasRecordatorios.length > 0; else sinReco">
            <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.TIUTLOLISTA' | translate}}</h2>
            <mat-dialog-content class="mat-typography">
                <p><b>{{'SHEDULE2_0.CARDS.PASO3.INFOHORA' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{'SHEDULE2_0.ZONAS.'+data.instituto | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
                <mat-list class="tac">
                    <mat-list-item *ngFor="let fecha of data.fechasRecordatorios; last as last">
                        <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
                        <!-- <h4 mat-line>{{fecha | slice: 0:10 | date:"fullDate":'':idiomaActual}}</h4> -->
                        <!-- <h4 mat-line>{{fecha | date:"medium":'+0000':idiomaActual}}</h4> -->
                        <!-- <h4 mat-line>{{fecha | date:"long":offsetPipe:idiomaActual}}</h4> -->
                        <h4 mat-line>{{fecha|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fecha|date:'z':offsetPipe:idiomaActual}})</h4>
                        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                    </mat-list-item>
                </mat-list>
            </mat-dialog-content>
        </ng-container>
        <ng-template #sinReco>
            <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO3.NORECOS' | translate}}</h2>
        </ng-template>
    </ng-container>

    <ng-container *ngIf="data.tipo == 'prorrogas'">
        <ng-container *ngIf="data.prorrogas.length > 0; else sinProrroga">
            <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO2_B.TIUTLOLISTA' | translate}}</h2>
            <mat-dialog-content class="mat-typography">
                <mat-list>
                    <mat-list-item *ngFor="let prorroga of data.prorrogas; last as last">
                        <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
                        <!-- <h4 mat-line>{{prorroga.fecha | slice: 0:10 | date:"fullDate":'':idiomaActual}}</h4> -->
                        <!-- <h4 mat-line>{{prorroga.fecha | date:"long":offsetPipe:idiomaActual}}</h4> -->
                        <h4 mat-line>{{prorroga.fecha|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{prorroga.fecha|date:'z':offsetPipe:idiomaActual}})</h4>
                        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                    </mat-list-item>
                </mat-list>
            </mat-dialog-content>
        </ng-container>
        <ng-template #sinProrroga>
            <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.PASO2_B.NOPROR' | translate}}</h2>
        </ng-template>
    </ng-container>

    <ng-container *ngIf="data.tipo == 'fechas'">
        <h2 mat-dialog-title>{{'SHEDULE2_0.CARDS.FECHAS.TITULO' | translate}}</h2>
        <mat-dialog-content class="mat-typography">
            <div fxLayout="column" fxLayoutAlign="start stretch">
                <p>{{'SHEDULE2_0.CARDS.FECHAS.INFO.1' | translate}}</p>
                <!-- <p><b>{{'SHEDULE2_0.CARDS.FECHAS.INFO.2' | translate}} {{'SHEDULE2_0.ZONAS.'+data.instituto | translate}} ({{horaInstitutoTag|date:"long":offsetPipe:idiomaActual}})</b></p> -->
                <p><b>{{'SHEDULE2_0.CARDS.FECHAS.INFO.2' | translate}} {{horaInstitutoTag|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{ city_name | translate}} {{horaInstitutoTag|date:'z':offsetPipe:idiomaActual}})</b></p>
                <mat-form-field class="calHid">
                    <input matInput #inputFecha [matDatepicker]="fechaGenerica" [matDatepickerFilter]="filtroCalendario" (dateChange)="fechaSeleccionada($event)" [formControl]="filtroCalendarioDefault">
                    <mat-datepicker touchUi #fechaGenerica></mat-datepicker>
                </mat-form-field>
                <div class="calHid">
                    <input placeholder="12hr format (default settings)" aria-label="12hr format" [ngxTimepicker]="horaGenerica" [format]="24" [min]="filtroHoraHoy" (opened)="horaAbierta($event)" id="timepicker" readonly>
                    <ngx-material-timepicker [enableKeyboardInput]="true" (closed)="salirSinHora($event)" (timeSet)="horaSeleccionada($event)" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn" [editableHintTmpl]="dialHint" #horaGenerica></ngx-material-timepicker>
                    <ng-template #cancelBtn>
                        <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CANCELAR' | translate}}</button>
                    </ng-template>
                    <ng-template #confirmBtn>
                        <button mat-raised-button color="accent" class="wsn m-20">{{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ACEPTAR' | translate}}</button>
                    </ng-template>
                    <ng-template #dialHint>
                        <b class="fechaSel">{{'SHEDULE2_0.CARDS.FECHAS.FECHA' | translate}} {{fechas[origen].fecha|date:"d MMM y":'':idiomaActual}}</b>
                    </ng-template>
                </div>
                <table mat-table [dataSource]="fechas" class="mat-elevation-z8">

                    <ng-container matColumnDef="tipoFecha">
                        <th mat-header-cell *matHeaderCellDef>{{'SHEDULE2_0.CARDS.FECHAS.TABLA.TIPO' | translate}}</th>
                        <td mat-cell *matCellDef="let fila">
                            <mat-icon class="type-icon mr-20">{{fila.icono}}</mat-icon> {{'SHEDULE2_0.CARDS.FECHAS.TIPOS.'+fila.tipo | translate}} </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaElegida">
                        <th mat-header-cell *matHeaderCellDef>{{'SHEDULE2_0.CARDS.FECHAS.TABLA.FECHA' | translate}}</th>
                        <td mat-cell *matCellDef="let fila">
                            <ng-container *ngIf="fila.cargando; else cargado;">
                                <mat-spinner *ngIf="!stpAllOk" diameter="30"></mat-spinner>
                            </ng-container>
                            <ng-template #cargado>
                                <ng-container *ngIf="fila.fecha != ''; else sinFecha">
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <!-- <div class="h4 secondary-text mr-20"><b>{{fila.fecha|date:"short":'+0000':idiomaActual}}</b></div> -->
                                        <!-- <div class="h4 secondary-text mr-20"><b>{{fila.fecha|date:"long":offsetPipe:idiomaActual}}</b></div> -->
                                        <div class="h4 secondary-text mr-20"><b>{{fila.fecha|date:"d MMM y H:mm":offsetPipe:idiomaActual}} ({{fila.fecha|date:'z':offsetPipe:idiomaActual}})</b></div>
                                        <div class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                                            <mat-icon class="s-20">done</mat-icon>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-template #sinFecha>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <div class="h4 secondary-text mr-20"><b>{{'SHEDULE2_0.CARDS.FECHAS.NOTYET' | translate}}</b></div>
                                        <div class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
                                            <mat-icon class="s-20">priority_high</mat-icon>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>{{'SHEDULE2_0.CARDS.FECHAS.TABLA.ACCIONES' | translate}}</th>
                        <td mat-cell *matCellDef="let fila; let i = index;">
                            <ng-container *ngIf="!fila.cargando">
                                <div fxLayout="column" fxLayoutAlign="start center">
                                    <ng-container *ngIf="fila.elegida == true; else botElegir">
                                        <button *ngIf="fila.visible" mat-raised-button color="accent" class="wsn ml-20" (click)="resetFecha();setOrigen(fila.tipo);fechaGenerica.open();" [disabled]="data.pasoCompleto">
                  {{'SHEDULE2_0.CARDS.FECHAS.BOTONES.CAMBIAR' | translate}}
                  <mat-icon class="ml-20">calendar_today</mat-icon>
                </button>
                                    </ng-container>
                                    <ng-template #botElegir>
                                        <button *ngIf="i == 0 && fila.visible" mat-raised-button color="accent" class="wsn m-10" (click)="resetFecha();setOrigen(fila.tipo);fechaGenerica.open();" [disabled]="data.pasoCompleto">
                  {{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ELEGIR' | translate}}
                  <mat-icon class="ml-20">calendar_today</mat-icon>
                </button>
                                        <button *ngIf="i > 0 && fila.visible" mat-raised-button color="accent" class="wsn m-10" (click)="resetFecha();setOrigen(fila.tipo);fechaGenerica.open();" [disabled]="!fechas[i-1].elegida || data.pasoCompleto || bloquearLanzamiento">
                  {{'SHEDULE2_0.CARDS.FECHAS.BOTONES.ELEGIR' | translate}}
                  <mat-icon class="ml-20">calendar_today</mat-icon>
                </button>
                                    </ng-template>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnas"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnas;"></tr>
                </table>
            </div>

        </mat-dialog-content>
    </ng-container>
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
{{'SHEDULE2_0.CERRAR' | translate}}
<mat-icon class="ml-20">clear</mat-icon>
</button>
</div>